import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ isDarkMode }) => {
  return (
    <section className={`${isDarkMode ? 'bg-gray-900' : 'bg-white'} py-16 md:py-24`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Logo Text */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            <span className="text-[#3b82f6]">Civic</span>
            <span className="text-[#ef4444]">Duty</span>
          </h1>
          
          {/* Tagline */}
          <p className={`text-xl md:text-2xl lg:text-3xl mb-12 ${isDarkMode ? 'text-gray-100' : 'text-gray-900'} font-bold`} style={{ fontFamily: 'Inter, sans-serif' }}>
            <span className={isDarkMode ? 'text-gray-200' : 'text-black'}>Putting</span>{' '}
            <span className="text-[#3b82f6]">People</span>{' '}
            <span className="bg-gradient-to-r from-[#3b82f6] to-[#ef4444] bg-clip-text text-transparent">&</span>{' '}
            <span className="text-[#ef4444]">Politics</span>{' '}
            <span className={isDarkMode ? 'text-gray-200' : 'text-black'}>Together</span>
          </p>
          
          {/* CTA Button */}
          <Link
            to="/"
            className="inline-flex items-center px-8 py-4 bg-[#ef4444] text-white text-lg font-semibold rounded-lg hover:bg-[#dc2626] transition-colors shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Get Started
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
